/** Junta classes condicionais ignorando valores falsy. Sem dependências. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
